export default "__VITE_ASSET__De70RdaL__"